import { useEffect, useRef } from 'react';

export default function ConfirmModal({ open, title, message, onConfirm, onCancel, confirmText = 'Confirmer', cancelText = 'Annuler', variant = 'danger' }) {
  const confirmRef = useRef(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => confirmRef.current?.focus(), 100);
    }
  }, [open]);

  if (!open) return null;

  const btnColors = {
    danger: 'bg-red-600 hover:bg-red-700',
    warning: 'bg-yellow-600 hover:bg-yellow-700',
    primary: 'bg-blue-600 hover:bg-blue-700',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onCancel}>
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className="text-gray-600 mb-6 whitespace-pre-line">{message}</p>
        <div className="flex justify-end gap-3">
          <button onClick={onCancel} className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">{cancelText}</button>
          <button ref={confirmRef} onClick={onConfirm} className={`px-4 py-2 text-white rounded-lg transition-colors ${btnColors[variant] || btnColors.danger}`}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}
